import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class AnimatedCharacter extends Phaser.GameObjects.Container {
  constructor(scene, char) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.charType = char.name;
    this.shadowoffset = char.shadowoffset;
    this.armoffset = char.armoffset;

    this.shadow = ABCyaPhaser.Images.addImage(0, 0, `Char_${this.charType}_Shadow`, this);
    this.char = ABCyaPhaser.Images.addImage(0, 0, `CharBody_${this.charType}`, this);
    this.arms = ABCyaPhaser.Images.addImage(0, 0, `CharArms_${this.charType}`, this);
    this.arms.x = this.armoffset.x;
    this.arms.y = this.armoffset.y;
    this.shadow.y = this.char.getBounds().height - this.shadow.getBounds().height + this.shadowoffset;

    switch (this.charType) {
      case 'Smell':
        this.arms.setOrigin(.5, .5);
        break;
      case 'Sight':
        this.arms.setOrigin(.5, .5);
        break;
      case 'Taste':
        this.arms.setOrigin(.5, 1);
        this.arms.angle = 4;
        break;
      case 'Hear':
        this.arms.setOrigin(0, 1);
        this.arms.angle = 6;
        break;
      case 'Touch':
        this.arms.setOrigin(.5, .5);
        break;
    }

    this.call = this.scene.time.delayedCall(Phaser.Math.Between(400, 4000), () => {this.repeatTween();});
  }

  repeatTween() {
    let quickness;
    let uplen;
    let r;

    switch (this.charType) {
      case 'Smell':
        this.arms.setOrigin(.5, .5);
        quickness = Phaser.Math.Between(600,1200);
        uplen = Phaser.Math.Between(10,18);

        ABCyaPhaser.Tweens.addTween(this.arms, quickness, { delay: quickness / 2, y: this.armoffset.y - uplen }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this.arms, quickness, { y: this.armoffset.y }, Phaser.Math.Easing.Linear, () => {
            const waitime = Phaser.Math.Between(400, 4000);
            this.call = this.scene.time.delayedCall(waitime, () => {this.repeatTween();});
          });
        });
        break;
      case 'Sight':
        this.arms.setOrigin(.5, .5);
        quickness = Phaser.Math.Between(600,1200);

        ABCyaPhaser.Tweens.addTween(this.arms, quickness, { delay: quickness / 2, scaleX: 1.05, scaleY: 1.05, x: this.armoffset.x + 2 }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this.arms, quickness, { scaleX: 1.0, scaleY: 1.0, x: this.armoffset.x }, Phaser.Math.Easing.Linear, () => {
            const waitime = Phaser.Math.Between(400, 4000);
            this.call = this.scene.time.delayedCall(waitime, () => {this.repeatTween();});
          });
        });
        break;
      case 'Taste':
        this.arms.setOrigin(.5, 1);
        this.arms.angle = 4;
        quickness = Phaser.Math.Between(600,1200);
        r = 4;

        ABCyaPhaser.Tweens.addTween(this.arms, quickness, { delay: 10, angle: -r }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this.arms, quickness, { angle: r }, Phaser.Math.Easing.Linear, () => {
            const waitime = Phaser.Math.Between(400, 4000);
            this.call = this.scene.time.delayedCall(waitime, () => {this.repeatTween();});
          });
        });
        break;
      case 'Hear':
        this.arms.setOrigin(0, 1);

        quickness = Phaser.Math.Between(600,1200);
        r = 6;
        this.arms.angle = 6;

        ABCyaPhaser.Tweens.addTween(this.arms, quickness, { delay: 10, angle: -r }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this.arms, quickness, { angle: r }, Phaser.Math.Easing.Linear, () => {
            const waitime = Phaser.Math.Between(400, 4000);
            this.call = this.scene.time.delayedCall(waitime, () => {this.repeatTween();});
          });
        });
        break;
      case 'Touch':
        this.arms.setOrigin(.5, .5);

        quickness = Phaser.Math.Between(600,1200);
        uplen = Phaser.Math.Between(10,18);

        ABCyaPhaser.Tweens.addTween(this.arms, quickness, { delay: quickness / 2, y: this.armoffset.y - uplen }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this.arms, quickness, { y: this.armoffset.y }, Phaser.Math.Easing.Linear, () => {
            const waitime = Phaser.Math.Between(400, 4000);
            this.call = this.scene.time.delayedCall(waitime, () => {this.repeatTween();});
          });
        });
        break;
    }
  };

  scaleInShadow(waitime, startScale, endScale) {
    this.shadow.scaleX = startScale;
    this.shadow.scaleY = startScale;
    this.shadow.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.shadow, 100, { delay: waitime + 400, alpha: 1 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.shadow, 320, { scaleX: endScale, scaleY: endScale }, Phaser.Math.Easing.Quadratic.Out);
    });
  };

  destroy() {
    this.scene.tweens.killTweensOf(this.arms);
    this.scene.tweens.killTweensOf(this.shadow);
    this.call?.destroy();

    this.removeAll(true);
  };
}